<template>
  <div v-if="product.curated_reviews" class="buybox__curated-reviews">
    <div v-if="yotpoProductId" class="product__reviews">
      <div class="yotpo bottomLine" data-appkey="SmtoQBJliJwFrBjSYjmEtOz31o6nMoLZfgcp3J4j" :data-product-id="yotpoProductId"></div>
    </div>
    <div class="text-xl buybox__curated-reviews-title">{{ product.curated_reviews.title }}</div>
    <p class="buybox__curated-reviews-review">{{product.curated_reviews.review }}</p>
    <div class="buybox__curated-reviews-reviewer mobile-text-base" v-html="product.curated_reviews.reviewer "></div>
  </div>
</template>

<script setup>
  import { computed, toRefs} from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    }
  })

  const { product } = toRefs(props);

  const yotpoProductId = computed(() => {
    const { tags } = product.value;
    const reviewTag = tags.find(tag => tag.startsWith("review-product-id="));
    if(!reviewTag) return product.value.id;
    
    return reviewTag.split('=')[1];
  })
</script>